import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
// import Layout from "../../components/Layout";
import { mapDispatchToProps } from "../../../store/helpers/mapDispatch";
import { mapStateToProps } from "../../../store/helpers/mapState";
import MinutesDetailsComponent from "../../../components/Meetings/MinutesDetails";
import { successToast } from "helpers/Notification";
import { errorToast } from "helpers/Notification";

const MeetingDetails = (props) => {
  const {
    ShareMinutes,
    location,
    DownloadDocumentById,
    loggedUser,
    GeneralDownload,
    GetMinutesDetails,
    minutesDetails,
    GetEmployees,
    PutAction,
    GetAllResources,
    resources,
    systemSettings
  } = props;
  const [content, setContent] = useState("");
  const [selectedUsers, setSelectedUsers] = React.useState([]);
  const [howToShare, setHowToShare] = React.useState("Specific");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const minutesId = location.pathname.split('/')[4];

  //add selected users on user
  const onSelectUser = (email) => {
    let temp = [...selectedUsers];
    temp.push(email);
    setSelectedUsers(temp);
  };
  // useEffect(() => {
  //   setSelectedUsers([]);
  // }, [howToShare]);

  useEffect(() => GetMinutesDetails(minutesId), []);
  useEffect(() => {
    GetAllResources();
  }, [])

const onSubmitAction = async (data) => {
    const response = await PutAction(`api/meeting-action/${data?.id}`,data);
    if (response?.status) {
        successToast(response?.data?.message);
        GetMinutesDetails(minutesId)
    }else{
        errorToast(response?.response?.data?.message)
    }

};
  const onSubmit = () => {
    if (content?.trim() !== "") {
      const info = {
        minuteId: location?.state?.meeting?.Minutes[0]?.id || minutesId,
        content,
        subject,
        shareTo: selectedUsers,
        howToShare
      };
      ShareMinutes(info);
      setLoading(true)
    } else {
      setMessage("Email content and recipients are required!")
    }
  };

  useEffect(() => {
    if (content.trim() === "") {
      setMessage("Email content is required!")
    } else {
      setMessage("")
    }
  }, [content]);
  return (
    <div >
      <MinutesDetailsComponent
        loggedUser={loggedUser}
        location={location}
        GeneralDownload={GeneralDownload}
        DownloadDocumentById={DownloadDocumentById}
        selectedUsers={selectedUsers}
        // removeUser={removeUser}
        onSelectUser={onSelectUser}
        setSelectedUsers={setSelectedUsers}
        howToShare={howToShare}
        setHowToShare={setHowToShare}
        content={content}
        setContent={setContent}
        subject={subject}
        setSubject={setSubject}
        onSubmit={onSubmit}
        message={message}
        loading={loading}
        minutesDetails={minutesDetails}
        onSubmitAction={onSubmitAction}
        resources={resources?.data}
        GetEmployees={GetEmployees}
        systemSettings={systemSettings}
      />
    </div>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(MeetingDetails);
